import {React} from "react";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {CircularProgress, Typography} from "@mui/material";
import EditProfileIcon from "../../../Assets/images/icons/edit";
import {useNavigate} from "react-router-dom";
import Facebook from "../../../Assets/Svg/facebook2.svg";
import Instagram from "../../../Assets/Svg/instagram2.svg";
import Telegram from "../../../Assets/Svg/Telegram2.svg";
import Whatsapp from "../../../Assets/Svg/Whatsapp.svg";
import Skype from "../../../Assets/Svg/skype.svg";
import Tiktok from "../../../Assets/Svg/tiktok.svg";


const EditCard = ({ handleEdit, isEditLoading, editedProfile}) => { // Remove isEditing and setIsEditing props
    const navigate = useNavigate();

    return (
        <>
            <div className={'edit-card'}>
                <div className={'card justify-content-evenly'}>
                    <Button
                        startIcon={<EditProfileIcon/>}
                        onClick={handleEdit} // Always call handleEdit directly
                        variant="outlined"
                        className={'profile-edit-button'}
                        disabled={isEditLoading} // Disable while loading
                    >
                        {isEditLoading ? (
                            <CircularProgress size={18}/>
                        ) : (
                            "Save Changes"
                        )}
                    </Button>
                    <div className={'change-password-div'}>
                        <Typography className={'edit-card-title'}>
                            More info
                        </Typography>
                        <Button className={'reset-password-button'}
                                onClick={() => {
                                    navigate("/profile/change-password/verify");
                                }}
                        >
                            Change Password
                        </Button>
                    </div>
                    <div className={'social-icons'}>
                        <a href={'https://facebook.com/' + editedProfile.facebook} target={'blank'}>
                            <img src={Facebook} alt={'Facebook'}/>
                        </a>
                        <a href={'https://instagram.com/' + editedProfile.instagram} target={'blank'}>
                            <img src={Instagram} alt={'Instagram'}/>
                        </a>
                        <a href={'https://t.me/' + editedProfile.telegram} target={'blank'}>
                            <img src={Telegram} alt={'Telegram'}/>
                        </a>
                        <a href={'https://wa.me/' + editedProfile.whatsapp} target={'blank'}>
                            <img src={Whatsapp} alt={'Whatsapp'}/>
                        </a>
                        <a href={'skype:' + editedProfile.skype + '?chat'} target={'_blank'} rel="noopener noreferrer">
                            <img src={Skype} alt={'Skype'}/>
                        </a>
                        <a href={'https://www.tiktok.com/@' + editedProfile.tiktok} target={'_blank'}
                           rel="noopener noreferrer">
                            <img src={Tiktok} alt={'Tiktok'}/>
                        </a>
                    </div>

                </div>
            </div>
        </>
    );
};

export default EditCard;